import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';
import FoodCategories from './components/FoodCategories';
import WhyChooseUs from './components/WhyChooseUs';
import AppEcosystem from './components/AppEcosystem';
import Locations from './components/Locations';
import DownloadApp from './components/DownloadApp';
import Testimonials from './components/Testimonials';
import Corporate from './components/Corporate';
import FAQ from './components/FAQ';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import { useNavigate } from 'react-router-dom';

export default function HomePage() {
  const navigate = useNavigate()
  const [activeCity, setActiveCity] = useState('Abuja');

  

  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <Hero activeCity={activeCity} onCityMatch={setActiveCity} />
      <Stats />
      <HowItWorks />
      <FoodCategories />
      <WhyChooseUs />
      <AppEcosystem />
      <Locations activeCity={activeCity} onCitySelect={setActiveCity} />
      <DownloadApp />
      <Testimonials />
      <Corporate />
      <FAQ />
      <CTABanner />
      <Footer />
    </div>
  );
}
